<template>
  <div>
    <v-card>
      <v-card-title class="px-6 py-4">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <div class="subtitle-2 grey--text text--grey-100">
              {{ $t('table_title.matches') }}
            </div>
          </v-col>
          <v-col
            cols="auto"
            class="pl-2"
          >
            <variable-selector
              v-if="variables"
              :variables="variables"
              :dashboard="dashboard"
              category="GPS"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pa-0">
        <player-match-table
          :stats="events.data"
          :loading="events.loading"
          :pagination="events.pagination"
          :player="player"
          :table-headers="tableHeaders"
        />
      </v-card-text>
    </v-card>

    <v-row class="mt-6 mb-6">
      <v-col>
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'UXPCSTDR', label: $t('table_headers.weekly_load.total_duration'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('table_headers.weekly_load.total_duration') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col>
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'UXPCSTD', label: $t('card_title.total_distance'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.total_distance') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col cols="4">
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'CALETLDLHSR', label: $t('card_title.high_speed_running'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.player_high_speed_running') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col cols="4">
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'CALETLDLSP', label: $t('card_title.sprint_distance'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.sprint_distance') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col cols="4">
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'CACTCSVB3TD', label: $t('card_title.speed_zone_14.4_19.8'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.speed_zone_14.4_19.8') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col cols="4">
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'CACGCSMXV', label: $t('card_title.maximal_player_velocities'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.maximal_player_velocities') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col cols="4">
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'CAPGCSMXAC', label: $t('card_title.maximal_player_accelerations'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.maximal_player_accelerations') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col cols="4">
        <section class="fill-height">
          <line-chart
            class="fill-height"
            :colors="['#FF4560']"
            :raw-data="filterPlayerStats"
            :chart-value-keys="[ { key: 'CAPGCSMXDC', label: $t('card_title.minimal_player_decelerations'), type: 'line' } ]"
            x-value="end_at"
            y-value-prefix="player_stats."
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.minimal_player_decelerations') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PlayerApiService } from '@/data/services'
import { EventType } from '@/data/models'
import PlayerMatchTable from '@/components/players/PlayerMatchTable.vue'
import { orderBy } from 'lodash'
import LineChart from '@/components/charts/LineChart.vue'
import dayjs from 'dayjs'
import VariableSelector from '@/components/performance/VariableSelector.vue'
import { DashboardType } from '@/data/models/Dashboard'

export default {
  name: 'PlayerMatchView',
  components: { VariableSelector, LineChart, PlayerMatchTable },
  props: {
    player: {
      type: Object,
      default: () => ({})
    },
    tableHeaders: {
      type: Array,
      required: true
    },
    variables: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    events: {
      loading: false,
      data: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        last_page: undefined
      }
    },
    dashboard: DashboardType.INDIVIDUAL_PERFORMANCE
  }),
  computed: {
    filterPlayerStats() {
      return this.events.data.filter(event => {
        return event.player_stats && event.player_stats.UXPCSTDR
      })
    }
  },
  watch: {
    'events.pagination.current_page': function () {
      this.fetchPlayerStats()
    }
  },
  created() {
    this.fetchPlayerStats()
  },
  methods: {
    orderBy,
    fetchPlayerStats: async function () {
      this.events.loading = true

      try {
        const response = await PlayerApiService.getEvents(this.$route.params.id, {
          type: EventType.MATCH,
          page: this.events.pagination.current_page,
          per_page: this.events.pagination.per_page,
          orderBy: 'end_at',
          order: 'desc',
          to: dayjs().format('YYYY-MM-DD')
        })

        this.events.data = response.data
        this.events.pagination = response.meta
      } catch (e) {
        this.events.data = []
        throw e
      } finally {
        this.events.loading = false
      }
    }
  }
}

</script>

<style scoped>

</style>
